import MicroModal from 'micromodal';

export default function () {
  const widgetName = 'managedPopUp';
  const widgetOpts = managedPopUpOpts;  

  // Storage selector-------------
  const sectionTrigger = "homepage";
  
  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (data) {    
      const d = data.items[0];
      // console.log("d:", d); // Log the value of d 
    

      function initializePopupModal() {
        $('body').append(`
          <div class="micromodal-slide" id="modal" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1">
              <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                <label class="modal-close-btn" data-micromodal-close>X</label>             
                <iframe src="${FULLCLIENTTHEMEPATH}static/popup.html?sv=${SITEVERSION}" frameborder="0" id="popupIframe"></iframe>
              </div>
            </div>
          </div>
        `);

        MicroModal.show('modal');
      }
      
      function handlePopup() {
        if ($('body').hasClass(sectionTrigger)) {
          if (navigator.cookieEnabled) {
           
            if (Cookies.get('modalCookie')) {
              
              $('#stateFairModal').remove();
            } else {
              
              setTimeout(() => {
                Cookies.set('modalCookie', 'modalCookie', { expires: 30 }); // Cookie expires in 30 days
                initializePopupModal();
              }, 1200);
            }
          } else {
           
            const modalShown = sessionStorage.getItem('modalShown');
      
            if (!modalShown) {
              
              initializePopupModal();
              sessionStorage.setItem('modalShown', 'true'); 
            }
          }
        } else {
          
          $('#stateFairModal').remove();
        }
      }
      handlePopup();
    },      
    itemsPerPanel: 1,
    link: [],
    maxItemsVisible: 1,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
  });
}
